import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormHelper } from 'src/app/shared/helpers/form.helper';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { PopupService } from 'src/app/shared/services/popup.service';

@Component({
  selector: 'auth-set-password-form',
  templateUrl: './set-password-form.component.html',
  styleUrls: ['./set-password-form.component.scss'],
  standalone: false,
})
export class SetPasswordFormComponent implements OnInit {
  @Input() isActivation: boolean;
  @Input() token: string;
  @Input() confirmButtonText: string;
  @Output() passwordChange: EventEmitter<void> = new EventEmitter<void>();

  form = this.formBuilder.group(
    {
      password: null as string,
      currentPassword: [{ value: '', disabled: true }, [Validators.required]],
      agreeTermsOfUse: [{ value: false, disabled: true }, [Validators.requiredTrue]],
    },
  );

  get f() {
    return this.form.controls;
  }

  constructor(private formBuilder: FormBuilder, private apiService: ApiService, private popupService: PopupService) { }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm(): void {
    if (!this.token) {
      this.f.currentPassword.enable();
    }
    if (this.isActivation) {
      this.f.agreeTermsOfUse.enable();
    }
  }

  isFieldInvalid(field: string): boolean {
    return FormHelper.isFieldInvalid(this.form, field);
  }

  async onSubmit(): Promise<void> {
    if (this.form.invalid) {
      return;
    }

    try {
      const currentPassword = this.token ? null : this.f.currentPassword.value;
      const newPassword = this.f.password.value;
      if (this.token) {
        await this.apiService.auth.finishPasswordReset(this.token, newPassword);
      } else {
        await this.apiService.auth.changePassword(currentPassword, newPassword);
      }
      this.popupService.showSnackBar(this.isActivation ? 'Account activated' : 'Your new password was saved');
      this.passwordChange.emit();
    } catch (error) {
      if (error instanceof HttpErrorResponse && error.error === 'Wrong password') {
        this.form.controls.currentPassword.setErrors({ wrongPassword: true });
      } else {
        await this.popupService.showInfo(
          '<span></br>If you are having issues resetting your password, please <a href="mailto:info@pointee.com">contact us</a>.</span>',
          'We could not save your new password',
          null,
        );
      }
    }
  }
}
